import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css'

const LoadingSpinner = ({ login }) => {
  const { t } = useTranslation();

  return (
    <div className={`spinner ${login ? 'login_page_alignment' : 'alignment'}`}>
      <div className="spinner-content">
        <span className="loading-text">Loading</span>
        <div className="half-spinner"></div>
        <span className="wait-text">Please wait...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;